/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect, useState } from 'react';

import { LoadingButton, SectionTitle } from 'components';
import { DatadisRenewalButton } from 'components/DatadisRenewalButton/DatadisRenewalButton';

import I18n from 'i18n-js';
import FullPageSyncLoader from 'components/FullPageSyncLoader';
import Modal from 'components/Modal/Modal';
// import CircularProgressBar from 'components/ProgressBar/ProgressBar';
import { toast } from 'react-toastify';

import './fix-comunidades-detalles-inscritos.module.scss';
import Button from 'components/Button/Button';
import { navigate } from 'navigation';
import { useLocation, useParams } from 'react-router-dom';

import { useToggle } from 'hooks/useToogle';
import ModalMatcher from 'components/ModalMatcher/ModalMatcher';
import solicitudesPendientesNuevoOnboarding from 'services/remote/SolicitudesPendientesNuevoOnboarding';
import { SolicitudPendiente } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import TabsInscrito from 'components/TabsInscrito/TabsInscrito';
import { OfertaRegistroAPI } from 'types/models/OfertasServiceNuevoOnboarding';
import ofertasService from 'services/remote/OfertasServiceNuevoOnboarding';
import InscritosServicentance from 'services/remote/Inscritos';
import { InscritosModel } from 'types/models/inscritos';
import customToast from 'components/CustomToast/CustomToast';
import ErrorMessages from 'types/enums/ErrorMessages';
import { LoggingService } from 'services';
import styles from './comunities-solicitudes-pendiente-list-page-new-onboarding-detalle.module.scss';
import DatosPersonales from './Tabs/datos-personales/datos-personales';
import DatosFacturas from './Tabs/datos-factura/datos-factura';
import Documentos from './Tabs/documentos/documentos';
import EncuestaObligatoria from './Tabs/encuesta-obligatoria/encuesta-obligatoria';
import Oferta from './Tabs/oferta/oferta';
import Historial from './Tabs/historial/historial';
import DatadisOrSignaturit from './Tabs/datadis-flujo/datadis-flujo';
import { getReminderActionState } from './reminderAction';

interface ParameterDetalles {
  communityID: string;
}
type Documento = {
  id: string;
  documento: string;
  nombre: string;
  tipo: string;
};
export const SolicitudRegistroDetalles = (props: any): JSX.Element => {
  // Props
  const {
    match: {
      params: { inscritosID },
    },
  } = props;
  const [loadingData, setLoadingData] = useState<boolean>(true);
  const [loadingDataOferta, setLoadingDataOferta] = useState<boolean>(true);
  const router = useLocation();
  const path = router.pathname || '';
  const [inscrito, setInscrito] = useState<InscritosModel>();
  const vieneDeInscritos = path.includes('/inscritos/') || path.includes('/inscritos');
  const vieneDeSolicitudes = path.includes('/solicitudes-pendientes/') || path.includes('/solicitud');
  const [isSwitchOn, toggleSwitch] = useToggle();
  const [isSwitchOnFinish, toggleSwitchFinish] = useToggle();
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingRecordatorio, setLoadingRecordatorio] = useState(false);
  const [recordatorioEnviado, setRecordatorioEnviado] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [loadingSumsubmitReportChangesValidar, setLoadingSumsubmitReportChangesValidar] = useState(false);
  const [showSendToERP, setShowSendToERP] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);

  const [solicitudesPendientes, setSolicitudesPendientes] = useState<SolicitudPendiente>();
  const [ofertas, setOfertas] = useState<Partial<OfertaRegistroAPI>[]>([]);
  const [loadingDataCreate, setLoadingDataCreate] = useState<boolean>(false);
  const [imagenSeleccionada, setImagenSeleccionada] = useState<{
    [tipo: string]: { src: string; index: number };
  }>({});
  const ofertasConNuevaLinea =
    ofertas.length === 0 || ofertas.every((o) => !Object.values(o).some(Boolean)) ? [{}] : ofertas;

  const actualizarImagenPorTipo = (tipo: string, src: string, index: number) => {
    setImagenSeleccionada((prev) => ({
      ...prev,
      [tipo]: { src, index },
    }));
  };
  const [actualizar, setActualizar] = useState<boolean>(false);
  // const [setpdf] = useState<boolean>(false);
  const { communityID } = useParams<ParameterDetalles>();

  let url = '';
  if (vieneDeInscritos) {
    url = '/tecnic/inscritos';
  } else if (communityID) {
    url = `/tecnic/communities/${communityID}/solicitudes-pendientes-nuevo-onboarding`;
  } else {
    url = '/tecnic/solicitudes-pendientes';
  }
  useEffect(() => {
    if (vieneDeSolicitudes) {
      solicitudesPendientesNuevoOnboarding
        .getPendingRegistrationRequestsById(inscritosID)
        .then(async (response) => {
          setSolicitudesPendientes(response);
        })
        .then()
        .finally(() => {
          setLoadingData(false);
          setActualizar(false);
        });
    } else {
      InscritosServicentance.getInscritosById(inscritosID)
        .then(async (response) => {
          setInscrito(response);

          const solicitudId = response.solicitudDeRegistroId;
          if (!solicitudId) return;

          Promise.allSettled([
            solicitudesPendientesNuevoOnboarding.getPendingRegistrationRequestsById(solicitudId),
            ofertasService.getOfertasBySolicitud(solicitudId),
          ])
            .then(([solicitudRes, ofertasRes]) => {
              if (solicitudRes.status === 'fulfilled') {
                setSolicitudesPendientes(solicitudRes.value);
              } else {
                console.error('Error al obtener solicitud pendiente:', solicitudRes.reason);
              }

              if (ofertasRes.status === 'fulfilled') {
                setOfertas(ofertasRes.value);
              } else {
                console.error('Error al obtener ofertas:', ofertasRes.reason);
              }
            })
            .finally(() => {
              setLoadingData(false);
              setLoadingDataOferta(false);
              setActualizar(false);
            });
        })
        .catch((error) => {
          console.error('Error al obtener inscrito:', error);
          setLoadingData(false);
          setLoadingDataOferta(false);
        });
    }
  }, [actualizar]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const inputValue = document.getElementById('codigoPostal') as HTMLInputElement;
  if (inputValue) {
    inputValue.maxLength = 5;
  }

  const deleteConfiguracion = async (idConfiguracion: string | undefined): Promise<void> => {
    setLoadingDelete(true);
    if (idConfiguracion) {
      try {
        if (vieneDeInscritos) {
          // Eliminar inscrito validado
          await InscritosServicentance.deleteInscrito(idConfiguracion);
          navigate('/tecnic/inscritos'); // o a communityID si aplica
        } else {
          await solicitudesPendientesNuevoOnboarding.deleteSolicitud(idConfiguracion);

          if (communityID) {
            navigate(`/tecnic/communities/${communityID}/solicitudes-pendientes-nuevo-onboarding`);
          } else {
            navigate('/tecnic/solicitudes-pendientes-new-onboarding');
          }
        }
      } catch (error) {
        toast.error(`${I18n.t('Error deleting solicitud')}.`);
        setLoadingDelete(false);
      }
    }
  };

  const finalizarSolicitud = async (idConfiguracion: string | undefined): Promise<void> => {
    setLoadingDelete(true);
    if (idConfiguracion) {
      try {
        await solicitudesPendientesNuevoOnboarding.finalizarSolicitud(idConfiguracion);

        if (communityID) {
          navigate(`/tecnic/communities/${communityID}/solicitudes-pendientes-nuevo-onboarding`);
        } else {
          navigate('/tecnic/solicitudes-pendientes-new-onboarding');
        }
      } catch (error) {
        toast.error(error);
        setLoadingDelete(false);
      }
    }
  };

  const submitReportChangesValidar = async (
    action: 'validar' | 'sendToERP',
    InscritosUpdate: InscritosModel,
  ): Promise<boolean> => {
    const object = InscritosUpdate;
    setLoadingSumsubmitReportChangesValidar(true);
    try {
      if (action === 'validar') {
        await InscritosServicentance.putInscritoValidado(object);
        customToast.success(I18n.t('Inscrito validado'));
      } else if (action === 'sendToERP') {
        await InscritosServicentance.sendInscritoToERP(object);

        customToast.success(I18n.t('Inscrito enviado al ERP'));
      }

      InscritosServicentance.getInscritosById(inscritosID)
        .then(async (response) => {
          setInscrito(response);

          const solicitudId = response.solicitudDeRegistroId;
          if (!solicitudId) return;

          Promise.allSettled([
            solicitudesPendientesNuevoOnboarding.getPendingRegistrationRequestsById(solicitudId),
            ofertasService.getOfertasBySolicitud(solicitudId),
          ])
            .then(([solicitudRes, ofertasRes]) => {
              if (solicitudRes.status === 'fulfilled') {
                setSolicitudesPendientes(solicitudRes.value);
              } else {
                console.error('Error al obtener solicitud pendiente:', solicitudRes.reason);
              }

              if (ofertasRes.status === 'fulfilled') {
                setOfertas(ofertasRes.value);
              } else {
                console.error('Error al obtener ofertas:', ofertasRes.reason);
              }
            })
            .finally(() => {
              setLoadingData(false);
              setLoadingDataOferta(false);
              setActualizar(false);
            });
        })
        .catch((error) => {
          console.error('Error al obtener inscrito:', error);
          setLoadingData(false);
          setLoadingDataOferta(false);
        });
      setShow(false);
      setShowSendToERP(false);
    } catch (error: any) {
      if (error.response && error.response.data) {
        if (action === 'sendToERP') {
          const { data } = error.response;

          if (data && typeof data === 'string') {
            toast.error(` ${data}`);
          }
        } else if (Object.values(ErrorMessages).includes(error.response.data)) {
          const errorKey = Object.keys(ErrorMessages).find(
            (key) => ErrorMessages[key as keyof typeof ErrorMessages] === error.response.data,
          );
          if (errorKey) {
            toast.error(I18n.t(errorKey));
          }
        }
      } else {
        switch (error.response.status) {
          case 400:
            toast.error(I18n.t('YaValidado'));
            break;
          case 401:
            toast.error(I18n.t('Not authorized'));
            break;
          case 403:
            toast.error(I18n.t('Without access privileges'));
            break;
          case 404:
            toast.error(I18n.t('Inscrit not found on system'));
            break;
          default:
            toast.error(I18n.t('Unknown error occurred'));
            break;
        }
      }
      setShow(false);
      setShowSendToERP(false);
    } finally {
      setLoadingSumsubmitReportChangesValidar(false);
    }
    return true;
  };

  const enviarRecordatorio = async (idConfiguracion: string | undefined): Promise<void> => {
    if (!idConfiguracion || loadingRecordatorio || recordatorioEnviado) return;

    setLoadingRecordatorio(true);

    try {
      await solicitudesPendientesNuevoOnboarding.enviarRecordatorio(idConfiguracion);
      setRecordatorioEnviado(true);
    } catch (error) {
      toast.error(error);
      setRecordatorioEnviado(false);
      setLoadingDelete(false);
    } finally {
      setLoadingRecordatorio(false);
    }
  };

  function inferirTipoDesdeNombre(nombre: string): string {
    const lower = nombre.toLowerCase();
    if (lower.includes('dni_front')) return 'DNI_FRONT';
    if (lower.includes('dni_back')) return 'DNI_BACK';
    return 'FACTURA';
  }
  const documentos: Documento[] = vieneDeInscritos
    ? (inscrito?.documentos || []).map((doc) => ({
        id: String(doc.id),
        documento: doc.url,
        nombre: doc.nombre || String(doc.id),
        tipo: inferirTipoDesdeNombre(doc.nombre || ''), // puedes usar FACTURA como fallback
      }))
    : [...(solicitudesPendientes?.factura || []), ...(solicitudesPendientes?.dni || [])].map((doc) => ({
        id: String(doc.id),
        documento: doc.documento,
        nombre: String(doc.id),
        tipo: doc.tipo,
      }));

  const docsFactura = documentos.filter((doc) => doc.tipo === 'FACTURA');
  const docsDNIFront = documentos.filter((doc) => doc.tipo === 'DNI_FRONT');
  const docsDNIBack = documentos.filter((doc) => doc.tipo === 'DNI_BACK');

  const handleShow = () => setShow(true);

  const validateFormInscritos = (): boolean => {
    setSubmitDisabled(false);
    setErrors({});
    return true;
  };
  const delay = (durationMs: any) => new Promise((resolve) => setTimeout(resolve, durationMs));
  const submitReportChanges = async (InscritosUpdate: InscritosModel): Promise<boolean> => {
    const object = InscritosUpdate;
    if (object.tipoConsumo === 'domestico') {
      object.potenciaContratadaP4 = 0;
      object.potenciaContratadaP5 = 0;
      object.potenciaContratadaP6 = 0;
      object.terminoEnergiaP4 = 0;
      object.terminoEnergiaP5 = 0;
      object.terminoEnergiaP6 = 0;
    }
    try {
      await InscritosServicentance.putInscrito(object);
      customToast.success(I18n.t('Inscrito successfully updated'));
    } catch (error) {
      toast.error(I18n.t('Error updating report!'));
    }
    return true;
  };

  const submitFormForInscritos = async (): Promise<boolean> => {
    setLoading(true);
    setSubmitDisabled(true);
    submitReportChanges(inscrito as InscritosModel);
    setLoading(false);
    setSubmitDisabled(false);
    return true;
  };
  const handleClick = () => {
    if (validateFormInscritos()) {
      LoggingService.log('handleSubmit :: ok', { inscrito, solicitudesPendientes });
      submitFormForInscritos();
    } else {
      LoggingService.log('handleSubmit :: errors', { inscrito, errors });
    }
  };

  function handleChange<T>(fieldPath: string, value: T, _id?: string, checked?: boolean): void {
    // Para checkboxes, usar el parámetro checked (4to param) que es el estado real del checkbox
    let newValue: T | boolean | string = checked !== undefined ? checked : value;

    // El campo tarifaPVPC espera 'si'/'no' como string, no booleano
    if (fieldPath === 'tarifaPVPC' && typeof newValue === 'boolean') {
      newValue = newValue ? 'si' : 'no';
    }

    // Si el fieldPath es 'codigoPostalFiscal' y el valor tiene más de 4 caracteres, lo recorta a los primeros 4
    if (fieldPath === 'codigoPostalFiscal' && typeof newValue === 'string' && newValue.length > 4) {
      newValue = newValue.slice(0, 5) as unknown as T;
    }

    setInscrito(
      new InscritosModel().deserialize({
        ...inscrito,
        [fieldPath]: newValue,
        OTC: inscrito?.OTC ? 'si' : 'no',
      }),
    );
    inscrito?.setAttr(fieldPath, newValue);
  }
  const persona = vieneDeInscritos ? inscrito : solicitudesPendientes;
  const mensajeKey = vieneDeInscritos
    ? 'InscritosDetalle.mensajeModalDelete'
    : 'InscritosDetalle.mensajeModalSolcilicitud';

  const nombreCompleto = `${persona?.nombre ?? ''} ${persona?.apellidos ?? ''}`.trim();
  const nif = persona?.nif ?? '';
  const textoModal = `${I18n.t(mensajeKey)} ${nombreCompleto} NIF: ${nif}`;
  const idParaBorrar = vieneDeInscritos ? inscrito?.id : solicitudesPendientes?.id;
  let botonesInscritos = null;
  if (vieneDeInscritos) {
    if (inscrito?.validado === 'no') {
      botonesInscritos = (
        <>
          {' '}
          <div className={styles.eliminarInscriot}>
            <DatadisRenewalButton
              inscritoId={inscrito?.id || inscritosID}
              fechaCaducidadDatadis={inscrito?.fechaCaducidadDatadis}
              estadoRenovacionDatadis={inscrito?.estadoRenovacionDatadis}
            />
            <Button
              type="button"
              onClick={(): Promise<void> => navigate(url)}
              variant="secondary"
              text={I18n.t('Cancel')}
            />
            <Button
              className={styles.viewmore_button}
              variant="reddelete"
              type="button"
              onClick={() => {
                toggleSwitch();
              }}
              text={
                vieneDeInscritos
                  ? I18n.t(`InscritosDetalle.deleteInscrito`)
                  : I18n.t(`InscritosDetalle.deleteSolicitud`)
              }
            />

            {vieneDeInscritos && (
              <LoadingButton
                type="submit"
                text={I18n.t('Save')}
                disabled={submitDisabled}
                loading={loading}
                onClick={() => handleClick()}
              />
            )}
            <LoadingButton type="button" text={I18n.t('Validar')} onClick={handleShow} />
          </div>
        </>
      );
    } else {
      botonesInscritos = (
        <>
          <DatadisRenewalButton
            inscritoId={inscrito?.id || inscritosID}
            fechaCaducidadDatadis={inscrito?.fechaCaducidadDatadis}
            estadoRenovacionDatadis={inscrito?.estadoRenovacionDatadis}
          />
          <LoadingButton
            type="button"
            text={I18n.t(getReminderActionState(loadingRecordatorio, recordatorioEnviado).textKey)}
            onClick={() => enviarRecordatorio(solicitudesPendientes?.id)}
            variant="primary"
            disabled={getReminderActionState(loadingRecordatorio, recordatorioEnviado).disabled}
          />
          <LoadingButton
            type="button"
            text={I18n.t('acabarSolicitud')}
            onClick={toggleSwitchFinish}
            variant="secondary"
          />
        </>
      );
    }
  } else {
    botonesInscritos = (
      <div className={styles.eliminarInscriot}>
        <Button
          type="button"
          onClick={(): Promise<void> => navigate(url)}
          variant="secondary"
          text={I18n.t('Cancel')}
        />
        {vieneDeInscritos && (
          <LoadingButton
            type="submit"
            text={I18n.t('Save')}
            disabled={submitDisabled}
            loading={loading}
            onClick={() => handleClick()}
          />
        )}
        <Button
          className={styles.viewmore_button}
          variant="reddelete"
          type="button"
          onClick={() => {
            toggleSwitch();
          }}
          text={
            vieneDeInscritos ? I18n.t(`InscritosDetalle.deleteInscrito`) : I18n.t(`InscritosDetalle.deleteSolicitud`)
          }
        />
        <LoadingButton
          type="button"
          text={I18n.t(getReminderActionState(loadingRecordatorio, recordatorioEnviado).textKey)}
          onClick={() => enviarRecordatorio(solicitudesPendientes?.id)}
          variant="primary"
          disabled={getReminderActionState(loadingRecordatorio, recordatorioEnviado).disabled}
        />
        <LoadingButton
          type="button"
          text={I18n.t('acabarSolicitud')}
          onClick={toggleSwitchFinish}
          variant="secondary"
        />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      {loadingData && loadingDataOferta ? (
        <FullPageSyncLoader icon />
      ) : (
        <>
          <div className={styles.postflex}>
            {vieneDeInscritos ? (
              <SectionTitle text={I18n.t('Inscritos')} />
            ) : (
              <SectionTitle text={I18n.t('Solicitudes Pendientes')} />
            )}
            <div className={styles.positionValidar}>
              {' '}
              <div className={styles.postflexbutton}>{botonesInscritos}</div>
            </div>
          </div>

          <TabsInscrito
            tabs={[
              {
                id: 'datos-personales',
                label: I18n.t('Dades personals'),
                content: (
                  <DatosPersonales
                    vieneDeInscritos={vieneDeInscritos}
                    inscrito={inscrito}
                    solicitudesPendientes={solicitudesPendientes}
                    handleChange={handleChange}
                  />
                ),
              },
              {
                id: 'datos-factura',
                label: I18n.t('Dades factura'),
                content: (
                  <DatosFacturas
                    vieneDeInscritos={vieneDeInscritos}
                    inscrito={inscrito}
                    handleChange={handleChange}
                    solicitudesPendientes={solicitudesPendientes}
                  />
                ),
              },
              {
                id: 'datos-datadis',
                label: 'Datadis',
                content: (
                  <DatadisOrSignaturit iSDatdis={solicitudesPendientes?.permiso_procesado_mediante_datadis || false} />
                ),
              },
              {
                id: 'documentos',
                label: I18n.t('Documentos'),
                content: (
                  <Documentos
                    docsFactura={docsFactura}
                    docsDNIFront={docsDNIFront}
                    docsDNIBack={docsDNIBack}
                    actualizarImagenPorTipo={actualizarImagenPorTipo}
                    imagenSeleccionada={imagenSeleccionada}
                  />
                ),
              },

              {
                id: 'encuesta',
                label: I18n.t('Detalle encuesta obligatoria'),
                content: <EncuestaObligatoria solicitudesPendientes={solicitudesPendientes} />,
              },

              ...(vieneDeInscritos
                ? [
                    {
                      id: 'Ofertas',
                      label: 'Ofertas',
                      content: (
                        <Oferta
                          ofertas={ofertas}
                          ofertasConNuevaLinea={ofertasConNuevaLinea}
                          setOfertas={setOfertas}
                          inscritosID={inscrito?.solicitudDeRegistroId ?? ''}
                          loadingDataCreate={loadingDataCreate}
                          setLoadingDataCreate={setLoadingDataCreate}
                          solicitudId={inscrito?.solicitudDeRegistroId ?? ''}
                          idComunidad={inscrito?.idComunidad ?? 0}
                        />
                      ),
                    },
                  ]
                : []),
              ...(vieneDeInscritos
                ? []
                : [
                    {
                      id: 'historial',
                      label: I18n.t('Historial'),
                      content: <Historial solicitudesPendientes={solicitudesPendientes} />,
                    },
                  ]),
            ]}
          />

          <div className={styles.containerFormsTest}>
            {showSendToERP ? (
              <Modal
                title={
                  I18n.t('mensajeModalSolicitud') +
                  solicitudesPendientes?.nombre +
                  I18n.t('spacio') +
                  solicitudesPendientes?.apellidos
                }
                testbutton={I18n.t('Confirmar')}
                onClick2={() => setShowSendToERP(false)}
              />
            ) : null}
          </div>

          {show ? (
            <Modal
              title={I18n.t('mensajeModal') + inscrito?.nombre + I18n.t('spacio') + inscrito?.apellidos}
              body={I18n.t('mensajeModalBody')}
              onClick={async () => {
                if (inscrito) {
                  setLoadingSumsubmitReportChangesValidar(true);
                  await delay(1000);

                  setLoadingSumsubmitReportChangesValidar(false);

                  submitReportChangesValidar('validar', inscrito);
                }
              }}
              testbutton={I18n.t('Confirmar')}
              onClick2={() => setShow(false)}
              disabled={!inscrito}
              loading={loadingSumsubmitReportChangesValidar}
            />
          ) : null}
          {isSwitchOnFinish && (
            <ModalMatcher
              title={
                I18n.t('mensajeModal') + solicitudesPendientes?.nombre ||
                inscrito?.nombre + I18n.t('spacio') + solicitudesPendientes?.apellidos ||
                inscrito?.apellidos
              }
              body={I18n.t('mensajeModalBody')}
              onClick={() => finalizarSolicitud(solicitudesPendientes?.id)}
              testbutton={I18n.t('Confirmar')}
              loading={loadingDelete}
              onClick2={toggleSwitchFinish}
            />
          )}

          {isSwitchOn && (
            <ModalMatcher
              title={textoModal}
              body={textoModal}
              onClick={() => deleteConfiguracion(idParaBorrar)}
              testbutton={I18n.t('Confirmar')}
              loading={loadingDelete}
              onClick2={toggleSwitch}
            />
          )}
          {/* {solicitudesPendientes?.validado === 'no' ? ( */}

          {/* ) : null} */}
        </>
      )}
    </div>
  );
};
